// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__WQw3v","requiredAsterisk":"Info_requiredAsterisk__ZpVmT"};